module.exports = "/virtual-football-league/img/virtualf-video.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/virtualf-video.png
// module id = 2248
// module chunks = 4